(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["post-ride-routine"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initRoutine() {
    var vids = document.querySelectorAll('video[data-routine-video]');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function(){}); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (v.preload === 'none') v.preload = 'auto';
          var p = v.play(); if (p && p.catch) p.catch(function(){});
        } else { v.pause(); }
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initRoutine); } else { initRoutine(); }
})();

  } catch(e) { console.error(e); }
})();
})();
